import SelectableTabPanel from './SelectableTabPanel';
export default SelectableTabPanel;